<template>
  <section :class="{ 'width-fill':isTable}">
    <div
      v-show="!showUpload"
      :class="{
        'mg-b-0': marginBottom0,
        'file-box':!isShowDetail&&!isTable,
        'flex-sb-center':isTable,
        'width-fill':isTable,
        'file-box__detail':isShowDetail,
      }">
      <template  v-if="!isShowDetail">
        <template v-if="!isTable">
          <div
            class="file-info">
            <span>
              <slot>{{ defaultName }}</slot>
            </span>
          </div>
          <div
            class="btn-box"
            :class="[edit? 'btn-max-width': 'btn-min-width']">
            <v-button
              v-show="showDownload"
              plain
              type="primary"
              @click="downloadFile">Download</v-button>
            <template v-if="edit">
              <v-button
                plain
                type="danger"
                @click="handlerDelete">Delete</v-button>
              <v-upload
                btnType="warning"
                :btnPlain="true"
                label="Replace"
                :otherData="otherData"
                :uploadData="uploadData"
                :direct="direct"
                :notUpload="notUpload"
                @uploadForm="handleUploadForm"
                @uploadSuccess="handlerUploadSuccess" />
            </template>
          </div>
        </template>
        <template v-else>
          <div class="flex-sb-center width-fill">
            <span class="blue fs-14 pointer">
              <slot>{{ defaultName }}</slot>
            </span>
            <div
              class="btn-box flex-align-center table-btn"
            >
              <template v-if="edit">
                <v-upload
                  class="fs-14"
                  :btnPlain="true"
                  label="Replace"
                  btnType="text"
                  :otherData="otherData"
                  :uploadData="uploadData"
                  :direct="direct"
                  :notUpload="notUpload"
                  @uploadForm="handleUploadForm"
                  @uploadSuccess="handlerUploadSuccess" />
                <span
                  class="pointer mg-l-10 color-dark fs-14"
                  @click="handlerDelete">Delete</span>
              </template>
            </div>
          </div>
        </template>
      </template>
      <div  v-else>
        <div
          :class="{'flex-none':isShowDocName}"
          class="flex-sb">
          <div
            v-if="showLeftName"
            class="flex-column"
            :class="{'mg-b-10':isShowDocName}">
            <span
              v-if="!isNoneName"
              class="color-dark mg-b-10 word-break fw-400"
            >
              {{ defaultName }}
            </span>
            <span class="mg-b-10">{{uploadTime}}</span>
            <span v-if="uploadFrom"> <span class="block-circle">{{uploadFrom}}</span></span>
          </div>
          <div class="upload-content">
            <v-upload
              :card="true"
              :fileData="fileData"
              :otherData="otherData"
              :uploadData="uploadData"
              is-show-detail
              disabled
              :direct="direct"
              :notUpload="notUpload"
              @uploadForm="handleUploadForm"
              @uploadSuccess="handlerUploadSuccess"
              @dock="handlerDock"
            />
            <div
              class="btn-box"
              :class="[edit? 'btn-max-width': 'btn-min-width',isViewer?'btn-last':'']">
              <v-button
                v-if="showDownload&&noFile"
                gray
                icon="download"
                @click="downloadFile"></v-button>
              <template v-if="edit">
                <v-button
                  plain
                  red
                  class="mg-r-8"
                  icon="trash-alt"
                  @click="handlerDelete"></v-button>
              </template>

              <v-button
                v-if="isCarVehicle"
                gray
                class="mg-r-0"
                icon="upload"
                @click="handlerCarUpload">
              </v-button>
              <template v-else>
                <v-upload
                  v-if="!isViewer"
                  icon="upload"
                  btnPlain
                  gray
                  :isDetailImgBtn="true"
                  :otherData="otherData"
                  :uploadData="uploadData"
                  :direct="direct"
                  :notUpload="notUpload"
                  @uploadForm="handleUploadForm"
                  @uploadSuccess="handlerUploadSuccess" />
              </template>
            <!--            </v-button>-->
            </div>
          </div>
        </div>
        <el-image-viewer
          v-if="showViewer"
          :on-close="()=>{showViewer=false}"
          :url-list="imgList" />
      </div>
    </div>
    <div
      v-show="showUpload"
      :class="{
        'file-box':!isShowDetail,
        'file-box__detail':showUpload&&isShowDetail,
        'flex-none':isShowDocName
      }"
    >
      <v-upload
        class="mg-b-10"
        :btnType="uploadBtnType"
        :label="uploadLabel"
        :file-data="fileData"
        :notUpload="notUpload"
        :otherData="otherData"
        :uploadData="uploadData"
        :direct="direct"

        :card="isShowDetail"
        :isShowDetail="isShowDetail"
        @uploadForm="handleUploadForm"
        @uploadSuccess="handlerUploadSuccess" />
    </div>
  </section>

</template>
<script>
import {deleteOrderDriverFile, deleteOrderFile} from '@/api/order'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'FileContainer',
  components:{
    ElImageViewer
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    isCarVehicle: {
      type: Boolean,
      default: false
    },
    fileData: {
      type: [Object, Array],
      default: () => ({})
    },
    otherData: {
      type: Object,
      default: () => ({})
    },
    direct: {
      type: Number,
      default: 1 // 只上傳不入庫
    },
    uploadData: {
      type: Object,
      default: () => ({})
    },
    marginBottom0: {
      type: Boolean,
      default: false
    },
    hasDock: {
      type: Boolean,
      default: true
    },
    isNoneName: {
      type: Boolean,
      default: false
    },
    titleName:{
      type: String,
      default: 'this file'
    },
    uploadBtnType:{
      type: String,
      default: 'primary'
    },
    uploadLabel:{
      type: String,
      default: 'Upload file'
    },
    notUpload:{
      type: Boolean,
      default: false
    },
    showDownload:{
      type: Boolean,
      default: true
    },
    isShowDetail:{
      type: Boolean,
      default: false
    },
    isShowDocName:{
      type: Boolean,
      default: false
    },
    isViewer:{
      type: Boolean,
      default: false
    },
    showLeftName:{
      type: Boolean,
      default: true
    },
    isTable: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showViewer:false,
      imgList:[]
    }
  },
  computed: {
    noFile(){
      if(!this.fileData || !this.fileData.url) {
        return false
      }
      return true
    },
    defaultName() {
      if(!this.fileData || !this.fileData.url) {
        return 'No File'
      }
      return (this.fileData  && this.fileData.client_name)? this.fileData.client_name: 'document.pdf'
    },
    showUpload() {
      if(this.edit && (!this.fileData || !this.fileData.url)) {
        return true
      }
      return false
    },
    uploadFrom(){
      let {from} = this.fileData||{}
      let obj = {
        1:'System',
        4:'Client',
        3:'CS'
      }
      return obj[from]||''
    },
    uploadTime(){
      let {upload_date} = this.fileData||{}
      return upload_date||''
    }
  },
  methods: {
    handlerCarUpload(){
      this.$emit('carUpload')
    },
    handlerDock(){
      // if(this.isViewer){
      //   return
      // }
      this.$emit('dock',{
        fileData:this.fileData,
        uploadData:this.uploadData,
        title:this.titleName
      })
    },
    // handlerView(){
    //   this.$emit('dock',{
    //     fileData:this.fileData,
    //     uploadData:this.uploadData,
    //     title:this.titleName
    //   })
    // },
    handlerDelete() {
      if(this.isViewer){
        this.$emit('delete', this.otherData)
        return
      }
      this.$ConfirmBox({
        message: `Are you sure you wana delete ${this.titleName}?`
      }).then(() => {
        // 區分是否直接删除数据库
        if(this.direct === 0) {
          // 判斷是否為記名司機
          const { type } = this.uploadData
          if(type === 'nm_drvr_licence_pic' || type === 'nm_drvr_id_type_pic') {
            this.network().deleteOrderDriverFile()
          }
          else {
            this.network().deleteOrderFile()
          }
        }
        else {
          this.$emit('delete', this.otherData)
        }
      })
    },
    downloadFile() {
      if(this.fileData && this.fileData.url) {
        window.open(this.fileData.url, '_blank')
      } else {
        this.$message({
          type: 'warning',
          message: 'no file'
        })
      }
    },
    handlerUploadSuccess(uploadRsult) {
      this.$emit('uploadSuccess', uploadRsult)
    },
    handleUploadForm(uploadForm){
      this.$emit('uploadForm', uploadForm)
    },
    network() {
      return {
        deleteOrderFile: async () => {
          const { data } = await deleteOrderFile(this.uploadData)
          this.$emit('delete', this.otherData)
        },
        deleteOrderDriverFile: async () => {
          const { data } = await deleteOrderDriverFile({
            type: this.uploadData.type,
            order_id: this.uploadData.order_id,
            driver_num: this.uploadData.num
          })
          this.$emit('delete', this.otherData)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .file-box {
   &.mg-b-0 {
     margin-bottom: 0;
   }
   .mg-r-8{
     margin-right: 8px;
   }
   .mg-r-0{
     margin-right: 0!important;
   }
   position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding: 5px 15px;
        min-height: 65px;
        border: 1px solid #dddfe7;
        border-radius: 4px;
        background: #fcfcfc;
        .file-info {
          flex: 1;
          color: #616266;
          font-size: 16px;
          overflow-wrap: anywhere;
        }
        .btn-box {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
          align-items: center;
          .el-button {
            margin-left: 0;
            margin-right: 10px;
          }
        }
        .btn-max-width {
           min-width: 270px;
        }
        .btn-min-width {
          min-width: 100px;
        }
   &__detail{
     .upload-content{
       position: relative;
       width: 348px;
       .btn-max-width{
         margin-top: 0px;
         top: 15px;
         right: 15px;
       }
     }
     &.flex-none{
       display: inline-grid;
       .btn-max-width{
         margin-top: 36px;
       }
       .text-right__document{
         justify-content: start;
       }
     }
     .flex-sb{
       position: relative;
       &.flex-none{
         display: inline-grid;
         .word-break{
           word-break: break-word;
         }

       }
     }
     .btn-box{
       position:absolute ;
       display: flex;
       right: 10px;
       margin-top: 20px;
       top: 0px;
       .el-button {
         margin-left: 0;
         margin-right: 10px;
       }
       .mg-r-0{
         margin-right: 0;
       }
       &.btn-last{
         .el-button:last-child{
           margin-right: 0px!important;
         }
       }
     }
   }
   &__btn{
     text-align: right;
     margin-top: 10px;
     display: block;
   }
 }
 .block-circle {
   font-weight: 600;
   font-size: 12px;
   line-height: 18px;
   color: #586069;
   padding: 1px 12px;
   border: 1px solid #E1E4E8;
   border-radius: 100px;
   display: inline-block;
 }
 .table-btn{
   /deep/ .el-upload--text{
     .el-button{
       border: 0;
       .btn-label{
         font-size: 14px;
       }
     }
   }
 }

</style>
